import { rule } from "./rule";
import { and2Lazy } from "./_rule-binary-ops";

const all = (...rules) => rules.reduce(and2Lazy);

export const WRONG_PARAMS_MESSAGE =
	"Expected rule to have one of types: function, function[] or [function, string]";

const prepareRule = ruleParam => {
	if (process.env.NODE_ENV !== "production" && ruleParam == null) {
		throw TypeError(WRONG_PARAMS_MESSAGE);
	}

	if (typeof ruleParam === "function") return ruleParam;

	if (process.env.NODE_ENV !== "production" && !Array.isArray(ruleParam)) {
		throw TypeError(WRONG_PARAMS_MESSAGE);
	}

	if (ruleParam.length === 2) {
		const [predicate, message] = ruleParam;
		if (typeof predicate === "function" && typeof message === "string") {
			return rule(predicate, message);
		}
	}

	if (
		process.env.NODE_ENV !== "production" &&
		ruleParam.some(r => typeof r !== "function" && !Array.isArray(r))
	) {
		throw TypeError(WRONG_PARAMS_MESSAGE);
	}

	return all(...ruleParam.map(prepareRule));
};

export default prepareRule;
